import React, { useState } from 'react';
import Tilty from 'react-tilty';
import { useNavigate } from 'react-router-dom';
import Button from '@mui/material/Button';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CheckIcon from '@mui/icons-material/Check';
import IconButton from '@mui/material/IconButton';


import 'react-tabs/style/react-tabs.css';
import 'swiper/scss/pagination';
import 'swiper/scss/navigation';
import 'swiper/scss';

import img1 from '../../assets/images/layout/banner-01-new.png'
import { minWidth } from '@mui/system';

function Banner01(props) {
    const navigate = useNavigate();

    const handleButtonClick = () => {
        navigate('/presale');
    };
    const [copied, setCopied] = useState(false);



    const styles = {
        huge: {
            color: "#ded6b7",
            margin: 0,
            fontFamily: '"Winky Rough", sans-serif',
            fontSize: 'clamp(36px, 6vw, 80px)'
        },
        largeGreen: {
            color: "#7ba411",
            margin: 0,
            fontFamily: '"Winky Rough", sans-serif',
            fontSize: 'clamp(24px, 4vw, 55px)'
        },
        hugeYellow: {
            color: "#efbc00",
            margin: 0,
            fontFamily: '"Winky Rough", sans-serif',
            fontSize: 'clamp(36px, 6vw, 80px)'
        },
        ctaButton: {
            backgroundColor: '#efbc00',
            marginTop: 20,
            minWidth: 250,
            color: '#000',
            fontSize: 'clamp(16px, 3vw, 25px)',
            fontFamily: '"Winky Rough", sans-serif',
            fontWeight: 600,
            padding: '10px 20px'
        }
    };

    return (
        <section
            className="banner"
            style={{ backgroundColor: '#01653b', padding: '40px 0' }}
        >
            <div className="container">
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        flexWrap: 'wrap',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                    }}
                >
                    <div style={{ flex: '1 1 400px', padding: 20, minWidth: 300 }}>
                        <div className="banner__content text-md-start text-center">
                            <h2 style={styles.huge}>REKT?</h2>
                            <h3 style={styles.largeGreen}>GOOD,</h3>
                            <h3 style={styles.largeGreen}>NOW CLAIM</h3>
                            <h3 style={styles.largeGreen}>YOUR SHARE</h3>
                            <h2 style={styles.hugeYellow}>$OSCAR</h2>
                            <Tilty max={15} perspective={800}>
                                <Button
                                    variant="contained"
                                    style={styles.ctaButton}
                                    onClick={() => window.open('https://pump.fun/coin/DJm8QYhMBdGcuDitHoGsbCAJJvoMy1SWrJ2H5HBjpump', '_blank')}
                                >
                                    BUY $OSCARD2
                                </Button>
                            </Tilty>

                            <div style={{ marginTop: 60, display: 'flex', alignItems: 'center', color: '#ccc', fontSize: 16 }}>
                                <span style={{ fontSize: 25, fontWeight: 500, marginRight: 8}}>
                                    CA: DJm8QYhMBdGcuDitHoGsbCAJJvoMy1SWrJ2H5HBjpump
                                </span>
                                <IconButton
                                    onClick={() => {
                                        navigator.clipboard.writeText('DJm8QYhMBdGcuDitHoGsbCAJJvoMy1SWrJ2H5HBjpump');
                                        setCopied(true);
                                        setTimeout(() => setCopied(false), 1000);
                                    }}
                                    size="small"
                                    style={{ color: '#efbc00' }}
                                >
                                    {copied ? <CheckIcon fontSize="small" /> : <ContentCopyIcon fontSize="small" />}
                                </IconButton>
                            </div>

                        </div>
                    </div>

                    <Tilty
                        max={15}
                        perspective={800}
                    >
                        <div
                            style={{
                                flex: '1 1 600px',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                padding: 20,
                            }}
                        >
                            <img
                                src={img1}
                                alt="Rockie"
                                style={{
                                    width: '100%',
                                    maxWidth: '440px',
                                    height: 'auto',
                                }}
                            />
                        </div>
                    </Tilty>
                </div>
            </div>
        </section>



    );
}

export default Banner01;